
import React, { useMemo, useState } from "react";
import {
  Users,
  UserCheck,
  Clock3,
  UserX,
  Search,
  Plus,
  Eye,
  Pencil,
  Trash2,
  CheckCircle2,
  XCircle,
  Power,
  RotateCcw,
  ChevronLeft,
  ChevronRight,
  X,
  ImagePlus
} from "lucide-react";

const initialMembers = [
  {
    id: 1,
    memberId: "SKM001",
    name: "Arun Kumar",
    gender: "Male",
    dob: "1998-04-15",
    birthPlace: "Salem",
    birthTime: "07:30",
    mobile: "9876543210",
    fatherName: "R. Kumar",
    motherName: "Lakshmi",
    community: "Kongu Vellalar",
    subCommunity: "Thooran",
    nativePlace: "Salem",
    siblings: "1",
    familyType: "Nuclear",
    education: "B.E.",
    occupation: "Software Engineer",
    companyName: "IT Company",
    designation: "Developer",
    annualIncome: "6 - 10 Lakhs",
    workLocation: "Chennai",
    address: "Salem, Tamil Nadu",
    height: "175",
    weight: "70",
    complexion: "Fair",
    maritalStatus: "Unmarried",
    profilePicture: "",
    profileCreatedBy: "Self",
    familyFoodHabit: "Vegetarian",
    familyTemple: "Arulmigu Murugan Temple",
    familyTemplePlace: "Salem",
    familyAssets: "Own House and Land",
    approvalStatus: "Approved",
    accountStatus: "Active",
    registeredDate: "2026-10-10",
  },
  {
    id: 2,
    memberId: "SKM002",
    name: "Priya Devi",
    gender: "Female",
    dob: "2001-08-20",
    birthPlace: "Erode",
    birthTime: "06:15",
    mobile: "9876543211",
    fatherName: "S. Shankar",
    motherName: "Meena",
    community: "Kongu Vellalar",
    subCommunity: "Kannan",
    nativePlace: "Erode",
    siblings: "2",
    familyType: "Joint",
    education: "M.Sc.",
    occupation: "Teacher",
    companyName: "Private School",
    designation: "Teacher",
    annualIncome: "3 - 6 Lakhs",
    workLocation: "Erode",
    address: "Erode, Tamil Nadu",
    height: "160",
    weight: "55",
    complexion: "Wheatish",
    maritalStatus: "Unmarried",
    profilePicture: "",
    profileCreatedBy: "Parent",
    familyFoodHabit: "Vegetarian",
    familyTemple: "Local Temple",
    familyTemplePlace: "Erode",
    familyAssets: "Own House",
    approvalStatus: "Pending",
    accountStatus: "Active",
    registeredDate: "2026-10-12",
  },
  {
    id: 3,
    memberId: "SKM003",
    name: "Karthik Raj",
    gender: "Male",
    dob: "1996-02-10",
    birthPlace: "Namakkal",
    birthTime: "10:00",
    mobile: "9876543212",
    fatherName: "Rajendran",
    motherName: "Kala",
    community: "Kongu Vellalar",
    subCommunity: "Pillan",
    nativePlace: "Namakkal",
    siblings: "1",
    familyType: "Nuclear",
    education: "MBA",
    occupation: "Business",
    companyName: "Own Business",
    designation: "Owner",
    annualIncome: "10 - 15 Lakhs",
    workLocation: "Namakkal",
    address: "Namakkal, Tamil Nadu",
    height: "178",
    weight: "76",
    complexion: "Wheatish",
    maritalStatus: "Unmarried",
    profilePicture: "",
    profileCreatedBy: "Self",
    familyFoodHabit: "Non-Vegetarian",
    familyTemple: "Family Temple",
    familyTemplePlace: "Namakkal",
    familyAssets: "House, Land",
    approvalStatus: "Rejected",
    accountStatus: "Inactive",
    registeredDate: "2026-10-08",
  },
];

const emptyForm = {
  name: "",
  gender: "Male",
  birthPlace: "",
  dob: "",
  birthTime: "",
  mobile: "",
  fatherName: "",
  motherName: "",
  community: "Kongu Vellalar",
  subCommunity: "",
  nativePlace: "",
  siblings: "0",
  familyType: "Nuclear",
  education: "",
  occupation: "",
  companyName: "",
  designation: "",
  annualIncome: "",
  workLocation: "",
  address: "",
  height: "",
  weight: "",
  complexion: "",
  maritalStatus: "Unmarried",
  profilePicture: "",
  profileCreatedBy: "Self",
  familyFoodHabit: "",
  familyTemple: "",
  familyTemplePlace: "",
  familyAssets: "",
};

const sections = [
  {
    title: "Personal Information",
    description: "Basic details and birth information",
    fields: [
      { name: "name", label: "Full Name", required: true },
      {
        name: "gender",
        label: "Gender",
        type: "select",
        options: ["Male", "Female"],
        required: true,
      },
      { name: "dob", label: "Date of Birth", type: "date", required: true },
      { name: "birthPlace", label: "Place of Birth" },
      { name: "birthTime", label: "Time of Birth", type: "time" },
      {
        name: "mobile",
        label: "Mobile Number",
        type: "tel",
        required: true,
      },
      {
        name: "maritalStatus",
        label: "Marital Status",
        type: "select",
        options: ["Unmarried", "Widowed", "Divorced", "Awaiting Divorce"],
      },
      {
        name: "profileCreatedBy",
        label: "Profile Created By",
        type: "select",
        options: ["Self", "Father", "Mother", "Brother", "Sister", "Relative", "Guardian"],
      },
      {
        name: "profilePicture",
        label: "Profile Picture",
        type: "file",
      },
    ],
  },
  {
    title: "Family Information",
    description: "Parents, community and family background",
    fields: [
      { name: "fatherName", label: "Father Name" },
      { name: "motherName", label: "Mother Name" },
      { name: "community", label: "Community Name", required: true },
      { name: "subCommunity", label: "Sub Community Name" },
      { name: "nativePlace", label: "Native Place" },
      { name: "siblings", label: "Number of Siblings", type: "number" },
      {
        name: "familyType",
        label: "Family Type",
        type: "select",
        options: ["Nuclear", "Joint", "Extended"],
      },
      {
        name: "familyFoodHabit",
        label: "Family Food Habit",
        type: "select",
        options: ["Vegetarian", "Non-Vegetarian", "Both"],
      },
      { name: "familyTemple", label: "Family Temple" },
      { name: "familyTemplePlace", label: "Family Temple Place" },
      { name: "familyAssets", label: "Family Assets" },
    ],
  },
  {
    title: "Education & Career",
    description: "Qualification, occupation and income",
    fields: [
      { name: "education", label: "Highest Education" },
      { name: "occupation", label: "Occupation" },
      { name: "companyName", label: "Company Name" },
      { name: "designation", label: "Designation" },
      {
        name: "annualIncome",
        label: "Annual Income",
        type: "select",
        options: [
          "Below 3 Lakhs",
          "3 - 6 Lakhs",
          "6 - 10 Lakhs",
          "10 - 15 Lakhs",
          "15 - 25 Lakhs",
          "Above 25 Lakhs",
        ],
      },
      { name: "workLocation", label: "Work Location" },
    ],
  },
  {
    title: "Physical Details & Address",
    description: "Physical attributes and communication address",
    fields: [
      { name: "height", label: "Height (cm)", type: "number" },
      { name: "weight", label: "Weight (kg)", type: "number" },
      {
        name: "complexion",
        label: "Complexion",
        type: "select",
        options: ["Very Fair", "Fair", "Wheatish", "Dark"],
      },
      {
        name: "address",
        label: "Communication Address",
        type: "textarea",
        required: true,
        full: true,
      },
    ],
  },
];

function formatDate(value) {
  if (!value) return "—";
  return new Date(`${value}T00:00:00`).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function Badge({ children, color = "slate" }) {
  const styles = {
    green: "bg-emerald-50 text-emerald-700",
    amber: "bg-amber-50 text-amber-700",
    red: "bg-rose-50 text-rose-700",
    blue: "bg-blue-50 text-blue-700",
    slate: "bg-slate-100 text-slate-600",
  };

  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-[10px] font-semibold ${styles[color]}`}
    >
      {children}
    </span>
  );
}

function SummaryCard({ title, value, icon: Icon, color }) {
  const colors = {
    blue: "bg-blue-50 text-blue-600",
    green: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    red: "bg-rose-50 text-rose-600",
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-xs text-slate-500">{title}</p>
          <p className="mt-2 text-2xl font-bold text-slate-800">{value}</p>
        </div>
        <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${colors[color]}`}>
          <Icon size={21} />
        </div>
      </div>
    </div>
  );
}

function MemberFormModal({ member, onClose, onSave }) {
  const [form, setForm] = useState(() => ({
    ...emptyForm,
    ...(member || {}),
  }));
  const [formError, setFormError] = useState("");

  const updateField = (name, value) => {
    setForm((current) => ({ ...current, [name]: value }));
    setFormError("");
  };

  const submit = (event) => {
    event.preventDefault();

    if (!/^\d{10}$/.test(form.mobile)) {
      setFormError("Enter a valid 10-digit mobile number.");
      return;
    }

    if (form.dob) {
      const birthDate = new Date(`${form.dob}T00:00:00`);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age < 18 || age > 100) {
        setFormError("Member age must be between 18 and 100 years.");
        return;
      }
    }

    onSave(form);
  };

  const inputClass =
    "mt-1.5 w-full min-w-0 rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100";

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/50 p-3 sm:p-5">
      <div className="flex max-h-[94vh] w-full max-w-5xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4 sm:px-6">
          <div>
            <h2 className="text-lg font-bold text-slate-800">
              {member ? "Edit Member Profile" : "Register New Member"}
            </h2>
            <p className="mt-1 text-xs text-slate-500">
              Complete the registration details below.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"
            aria-label="Close form"
          >
            <X size={19} />
          </button>
        </div>

        <form onSubmit={submit} className="flex min-h-0 flex-1 flex-col">
          <div className="overflow-y-auto p-4 sm:p-6">
            {sections.map((section, sectionIndex) => (
              <section
                key={section.title}
                className={sectionIndex ? "mt-7 border-t border-slate-100 pt-6" : ""}
              >
                <div className="mb-4">
                  <h3 className="text-sm font-bold text-slate-800">
                    {section.title}
                  </h3>
                  <p className="mt-1 text-xs text-slate-400">
                    {section.description}
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                  {section.fields.map((field) => (
                    <div
                      key={field.name}
                      className={field.full ? "sm:col-span-2 lg:col-span-3" : ""}
                    >
                      <label className="text-xs font-semibold text-slate-600">
                        {field.label}
                        {field.required && <span className="text-rose-500"> *</span>}
                      </label>

                      {field.type === "select" ? (
                        <select
                          required={field.required}
                          value={form[field.name] || ""}
                          onChange={(event) =>
                            updateField(field.name, event.target.value)
                          }
                          className={inputClass}
                        >
                          <option value="">Select {field.label}</option>
                          {field.options.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      ) : field.type === "textarea" ? (
                        <textarea
                          required={field.required}
                          rows={3}
                          value={form[field.name] || ""}
                          onChange={(event) =>
                            updateField(field.name, event.target.value)
                          }
                          placeholder={`Enter ${field.label.toLowerCase()}`}
                          className={inputClass}
                        />
                      ) : field.type === "file" ? (
                        <div className="mt-1.5">
                          <label className="flex cursor-pointer items-center gap-3 rounded-lg border border-dashed border-slate-300 p-3 hover:border-blue-400 hover:bg-blue-50/30">
                            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
                              {form[field.name] ? (
                                <ImagePlus size={19} />
                              ) : (
                                <ImagePlus size={19} />
                              )}
                            </div>
                            <div className="min-w-0">
                              <p className="text-xs font-medium text-slate-700">
                                {form[field.name] || "Choose profile picture"}
                              </p>
                              <p className="mt-1 text-[10px] text-slate-400">
                                JPG or PNG image
                              </p>
                            </div>
                            <input
                              type="file"
                              accept="image/png,image/jpeg,image/webp"
                              className="hidden"
                              onChange={(event) => {
                                const file = event.target.files?.[0];
                                if (file) updateField(field.name, file.name);
                              }}
                            />
                          </label>
                        </div>
                      ) : (
                        <input
                          required={field.required}
                          type={field.type || "text"}
                          min={field.type === "number" ? 0 : undefined}
                          maxLength={field.type === "tel" ? 10 : undefined}
                          value={form[field.name] || ""}
                          onChange={(event) => {
                            const value =
                              field.type === "tel"
                                ? event.target.value.replace(/\D/g, "").slice(0, 10)
                                : event.target.value;
                            updateField(field.name, value);
                          }}
                          placeholder={`Enter ${field.label.toLowerCase()}`}
                          className={inputClass}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </section>
            ))}

            {formError && (
              <p role="alert" className="mt-5 rounded-lg bg-rose-50 px-3 py-2.5 text-xs text-rose-700">
                {formError}
              </p>
            )}
          </div>

          <div className="flex flex-col-reverse gap-2 border-t border-slate-100 bg-slate-50 px-4 py-4 sm:flex-row sm:justify-end sm:px-6">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700"
            >
              {member ? "Save Changes" : "Register Member"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function MemberDetails({ member, onClose, onEdit }) {
  if (!member) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/50 p-4">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-slate-100 p-5">
          <div>
            <h2 className="font-bold text-slate-800">Member Profile</h2>
            <p className="mt-1 text-xs text-slate-500">{member.memberId}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close details" className="rounded-lg p-2 hover:bg-slate-100">
            <X size={18} />
          </button>
        </div>

        <div className="max-h-[75vh] overflow-y-auto p-5">
          <div className="flex items-center gap-3 rounded-xl bg-blue-50 p-4">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 text-xl font-bold text-blue-700">
              {member.name?.charAt(0) || "M"}
            </div>
            <div>
              <h3 className="font-bold text-slate-800">{member.name}</h3>
              <p className="mt-1 text-xs text-slate-500">{member.mobile}</p>
              <div className="mt-2 flex flex-wrap gap-2">
                <Badge color={member.approvalStatus === "Approved" ? "green" : member.approvalStatus === "Pending" ? "amber" : "red"}>
                  {member.approvalStatus}
                </Badge>
                <Badge color={member.accountStatus === "Active" ? "green" : "slate"}>
                  {member.accountStatus}
                </Badge>
              </div>
            </div>
          </div>

          {sections.map((section) => (
            <div key={section.title} className="mt-5">
              <h4 className="mb-3 text-xs font-bold uppercase tracking-wide text-slate-500">
                {section.title}
              </h4>
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                {section.fields
                  .filter((field) => field.type !== "file")
                  .map((field) => (
                    <div key={field.name} className="rounded-lg bg-slate-50 p-3">
                      <p className="text-[10px] text-slate-400">{field.label}</p>
                      <p className="mt-1 break-words text-xs font-medium text-slate-700">
                        {field.name === "dob"
                          ? formatDate(member[field.name])
                          : member[field.name] || "—"}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={() => onEdit(member)}
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-700"
          >
            <Pencil size={15} /> Edit Member
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Members() {
  const [members, setMembers] = useState(initialMembers);
  const [search, setSearch] = useState("");
  const [approvalFilter, setApprovalFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [genderFilter, setGenderFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [viewingMember, setViewingMember] = useState(null);
  const [deleteMember, setDeleteMember] = useState(null);
  const [notice, setNotice] = useState("");

  const stats = useMemo(
    () => [
      { title: "Total Members", value: members.length, icon: Users, color: "blue" },
      { title: "Approved Members", value: members.filter((m) => m.approvalStatus === "Approved").length, icon: UserCheck, color: "green" },
      { title: "Pending Approval", value: members.filter((m) => m.approvalStatus === "Pending").length, icon: Clock3, color: "amber" },
      { title: "Inactive Members", value: members.filter((m) => m.accountStatus === "Inactive").length, icon: UserX, color: "red" },
    ],
    [members]
  );

  const filteredMembers = useMemo(() => {
    const term = search.trim().toLowerCase();

    return members.filter((member) => {
      const matchesSearch =
        !term ||
        member.name.toLowerCase().includes(term) ||
        member.memberId.toLowerCase().includes(term) ||
        member.mobile.includes(term);

      return (
        matchesSearch &&
        (!genderFilter || member.gender === genderFilter) &&
        (!approvalFilter || member.approvalStatus === approvalFilter) &&
        (!statusFilter || member.accountStatus === statusFilter) &&
        (!fromDate || member.registeredDate >= fromDate) &&
        (!toDate || member.registeredDate <= toDate)
      );
    });
  }, [members, search, genderFilter, approvalFilter, statusFilter, fromDate, toDate]);

  const totalPages = Math.max(1, Math.ceil(filteredMembers.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const startIndex = (safePage - 1) * pageSize;
  const visibleMembers = filteredMembers.slice(startIndex, startIndex + pageSize);

  const resetFilters = () => {
    setSearch("");
    setGenderFilter("");
    setApprovalFilter("");
    setStatusFilter("");
    setFromDate("");
    setToDate("");
    setPage(1);
  };

  const saveMember = (form) => {
    if (editingMember) {
      setMembers((current) =>
        current.map((member) =>
          member.id === editingMember.id ? { ...member, ...form } : member
        )
      );
      setNotice("Member profile updated successfully.");
    } else {
      const nextId =
        Math.max(
          0,
          ...members.map((member) => Number(member.memberId.replace("SKM", "")) || 0)
        ) + 1;

      setMembers((current) => [
        {
          ...form,
          id: Date.now(),
          memberId: `SKM${String(nextId).padStart(3, "0")}`,
          approvalStatus: "Pending",
          accountStatus: "Active",
          registeredDate: new Date().toISOString().slice(0, 10),
        },
        ...current,
      ]);

      setNotice("Member registered and sent for approval.");
      setPage(1);
    }

    setModalOpen(false);
    setEditingMember(null);
  };

  const updateMember = (id, changes, message) => {
    setMembers((current) =>
      current.map((member) =>
        member.id === id ? { ...member, ...changes } : member
      )
    );
    setNotice(message);
  };

  const openEdit = (member) => {
    setViewingMember(null);
    setEditingMember(member);
    setModalOpen(true);
  };

  const changeApproval = (member, approvalStatus) => {
    updateMember(
      member.id,
      { approvalStatus },
      `Member ${member.memberId}: ${approvalStatus.toLowerCase()}.`
    );
  };

  const toggleAccountStatus = (member) => {
    const nextStatus = member.accountStatus === "Active" ? "Inactive" : "Active";
    updateMember(
      member.id,
      { accountStatus: nextStatus },
      `${member.memberId} is now ${nextStatus.toLowerCase()}.`
    );
  };

  const deleteSelectedMember = () => {
    setMembers((current) =>
      current.filter((member) => member.id !== deleteMember.id)
    );
    setNotice(`Member ${deleteMember.memberId} removed from the sample list.`);
    setDeleteMember(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="mb-2 flex items-center gap-2 text-[11px] text-slate-400">
            <span>Home</span><span>/</span><span>Members</span><span>/</span>
            <span className="font-medium text-blue-600">Member List</span>
          </div>
          <h1 className="text-xl font-bold text-slate-800 sm:text-2xl">Member Management</h1>
          <p className="mt-1 text-xs text-slate-500 sm:text-sm">
            Register profiles, approve members and manage account status.
          </p>
        </div>

        <button
          type="button"
          onClick={() => {
            setEditingMember(null);
            setModalOpen(true);
          }}
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-3 text-xs font-semibold text-white hover:bg-blue-700"
        >
          <Plus size={17} /> Add Member
        </button>
      </div>

      {notice && (
        <div className="flex items-center justify-between rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          <span>{notice}</span>
          <button type="button" onClick={() => setNotice("")} aria-label="Dismiss">
            <X size={16} />
          </button>
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {stats.map((item) => <SummaryCard key={item.title} {...item} />)}
      </div>

      <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
        <div className="mb-4">
          <h2 className="text-sm font-bold text-slate-800">Search & Filters</h2>
          <p className="mt-1 text-xs text-slate-400">
            Search by name, member ID or mobile number.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
          <div className="relative">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
              placeholder="Name, member ID or mobile"
              className="w-full rounded-lg border border-slate-200 py-2.5 pl-9 pr-3 text-xs outline-none focus:border-blue-400"
            />
          </div>

          <select value={genderFilter} onChange={(e) => { setGenderFilter(e.target.value); setPage(1); }} className="rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-xs text-slate-600 outline-none">
            <option value="">All Genders</option><option>Male</option><option>Female</option>
          </select>

          <select value={approvalFilter} onChange={(e) => { setApprovalFilter(e.target.value); setPage(1); }} className="rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-xs text-slate-600 outline-none">
            <option value="">All Approval Statuses</option><option>Pending</option><option>Approved</option><option>Rejected</option>
          </select>

          <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }} className="rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-xs text-slate-600 outline-none">
            <option value="">All Account Statuses</option><option>Active</option><option>Inactive</option>
          </select>

          <input type="date" aria-label="Registered from" value={fromDate} onChange={(e) => { setFromDate(e.target.value); setPage(1); }} className="rounded-lg border border-slate-200 px-3 py-2.5 text-xs text-slate-600 outline-none" />
          <input type="date" aria-label="Registered to" min={fromDate || undefined} value={toDate} onChange={(e) => { setToDate(e.target.value); setPage(1); }} className="rounded-lg border border-slate-200 px-3 py-2.5 text-xs text-slate-600 outline-none" />
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-4">
          <p className="text-xs text-slate-500">
            Found <strong className="text-slate-800">{filteredMembers.length}</strong> member(s)
          </p>
          <button type="button" onClick={resetFilters} className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-4 py-2.5 text-xs font-semibold text-slate-600 hover:bg-slate-50">
            <RotateCcw size={14} /> Reset Filters
          </button>
        </div>
      </section>

      <section className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <div className="flex flex-col gap-3 border-b border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
          <div>
            <h2 className="text-sm font-bold text-slate-800">Registered Members</h2>
            <p className="mt-1 text-[11px] text-slate-400">Review profiles and manage approvals</p>
          </div>
          <div className="flex items-center gap-2 text-xs text-slate-500">
            Show
            <select value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setPage(1); }} className="rounded-md border border-slate-200 bg-white px-2 py-1.5">
              <option value={5}>5</option><option value={10}>10</option><option value={25}>25</option>
            </select>
            entries
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[1120px] text-left">
            <thead className="bg-slate-50">
              <tr className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">
                <th className="px-5 py-3">Member</th>
                <th className="px-4 py-3">Gender / DOB</th>
                <th className="px-4 py-3">Mobile</th>
                <th className="px-4 py-3">Community</th>
                <th className="px-4 py-3">Approval</th>
                <th className="px-4 py-3">Account Status</th>
                <th className="px-4 py-3">Registered</th>
                <th className="px-5 py-3 text-right">Actions</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-100">
              {visibleMembers.map((member) => (
                <tr key={member.id} className="hover:bg-slate-50/70">
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-2.5">
                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-50 text-xs font-bold text-blue-600">
                        {member.name.charAt(0)}
                      </div>
                      <div>
                        <p className="whitespace-nowrap text-xs font-semibold text-slate-800">{member.name}</p>
                        <p className="mt-1 text-[10px] text-blue-600">{member.memberId}</p>
                      </div>
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-4 py-4 text-xs text-slate-600">
                    {member.gender}<p className="mt-1 text-[10px] text-slate-400">{formatDate(member.dob)}</p>
                  </td>
                  <td className="whitespace-nowrap px-4 py-4 text-xs text-slate-600">{member.mobile}</td>
                  <td className="whitespace-nowrap px-4 py-4 text-xs text-slate-600">
                    {member.community}<p className="mt-1 text-[10px] text-slate-400">{member.subCommunity || "—"}</p>
                  </td>
                  <td className="whitespace-nowrap px-4 py-4">
                    <Badge color={member.approvalStatus === "Approved" ? "green" : member.approvalStatus === "Pending" ? "amber" : "red"}>
                      {member.approvalStatus}
                    </Badge>
                  </td>
                  <td className="whitespace-nowrap px-4 py-4">
                    <button
                      type="button"
                      onClick={() => toggleAccountStatus(member)}
                      title="Toggle account status"
                      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-[10px] font-semibold ${member.accountStatus === "Active" ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`}
                    >
                      <Power size={12} />
                      {member.accountStatus}
                    </button>
                  </td>
                  <td className="whitespace-nowrap px-4 py-4 text-xs text-slate-500">{formatDate(member.registeredDate)}</td>
                  <td className="px-5 py-4">
                    <div className="flex items-center justify-end gap-1">
                      <button type="button" title="View profile" aria-label={`View ${member.name}`} onClick={() => setViewingMember(member)} className="rounded-lg p-2 text-blue-600 hover:bg-blue-50"><Eye size={15} /></button>
                      <button type="button" title="Edit profile" aria-label={`Edit ${member.name}`} onClick={() => openEdit(member)} className="rounded-lg p-2 text-amber-600 hover:bg-amber-50"><Pencil size={15} /></button>
                      {member.approvalStatus === "Pending" && (
                        <>
                          <button type="button" title="Approve member" aria-label={`Approve ${member.name}`} onClick={() => changeApproval(member, "Approved")} className="rounded-lg p-2 text-emerald-600 hover:bg-emerald-50"><CheckCircle2 size={16} /></button>
                          <button type="button" title="Reject member" aria-label={`Reject ${member.name}`} onClick={() => changeApproval(member, "Rejected")} className="rounded-lg p-2 text-rose-600 hover:bg-rose-50"><XCircle size={16} /></button>
                        </>
                      )}
                      <button type="button" title="Delete member" aria-label={`Delete ${member.name}`} onClick={() => setDeleteMember(member)} className="rounded-lg p-2 text-rose-600 hover:bg-rose-50"><Trash2 size={15} /></button>
                    </div>
                  </td>
                </tr>
              ))}

              {visibleMembers.length === 0 && (
                <tr>
                  <td colSpan={8} className="px-5 py-14 text-center">
                    <Users size={28} className="mx-auto text-slate-300" />
                    <p className="mt-3 text-sm font-semibold text-slate-700">No members found</p>
                    <p className="mt-1 text-xs text-slate-400">Change your search or filters and try again.</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex flex-col gap-3 border-t border-slate-100 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5">
          <p className="text-[11px] text-slate-500">
            Showing {filteredMembers.length ? startIndex + 1 : 0} to {Math.min(startIndex + pageSize, filteredMembers.length)} of {filteredMembers.length} entries
          </p>
          <div className="flex items-center gap-1 self-end sm:self-auto">
            <button type="button" disabled={safePage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))} className="rounded-lg border border-slate-200 p-2 text-slate-500 disabled:opacity-40" aria-label="Previous page"><ChevronLeft size={15} /></button>
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .filter((number) => number === 1 || number === totalPages || Math.abs(number - safePage) <= 1)
              .map((number, index, numbers) => (
                <React.Fragment key={number}>
                  {index > 0 && number - numbers[index - 1] > 1 && <span className="px-1 text-xs text-slate-400">...</span>}
                  <button type="button" onClick={() => setPage(number)} className={`h-8 min-w-8 rounded-lg px-2 text-xs font-medium ${safePage === number ? "bg-blue-600 text-white" : "border border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{number}</button>
                </React.Fragment>
              ))}
            <button type="button" disabled={safePage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))} className="rounded-lg border border-slate-200 p-2 text-slate-500 disabled:opacity-40" aria-label="Next page"><ChevronRight size={15} /></button>
          </div>
        </div>
      </section>

      {modalOpen && (
        <MemberFormModal
          member={editingMember}
          onClose={() => { setModalOpen(false); setEditingMember(null); }}
          onSave={saveMember}
        />
      )}

      {viewingMember && (
        <MemberDetails
          member={viewingMember}
          onClose={() => setViewingMember(null)}
          onEdit={openEdit}
        />
      )}

      {deleteMember && (
        <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/50 p-4">
          <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-rose-50 text-rose-600"><Trash2 size={22} /></div>
            <h3 className="mt-4 text-center text-lg font-bold text-slate-800">Delete Member?</h3>
            <p className="mt-2 text-center text-sm text-slate-500">
              Delete {deleteMember.name} ({deleteMember.memberId}) from this sample list?
            </p>
            <div className="mt-6 flex gap-3">
              <button type="button" onClick={() => setDeleteMember(null)} className="flex-1 rounded-lg border border-slate-200 px-4 py-2.5 text-sm text-slate-600">Cancel</button>
              <button type="button" onClick={deleteSelectedMember} className="flex-1 rounded-lg bg-rose-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-rose-700">Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
